import { Component, EventEmitter, Output } from '@angular/core';
import { constants } from '../../../../environments/constants';
import { KENDO_APPBAR } from '@progress/kendo-angular-navigation';
import { KENDO_SPLITBUTTON } from '@progress/kendo-angular-buttons';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-account-not-found',
  imports: [KENDO_APPBAR,KENDO_SPLITBUTTON,CommonModule],
  templateUrl: './account-not-found.component.html',
  styleUrl: './account-not-found.component.css'
})
export class AccountNotFoundComponent {
  @Output() iconClicked = new EventEmitter<string>();
  headerStyle = {
      'background-color': constants.headerBackgroundColor
  };

  navigate(str: string) {
    this.iconClicked.emit(str);
  }
  
}
